"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modal = exports.CloseButton = exports.Backdrop = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ = require("../..");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Backdrop = exports.Backdrop = _styledComponents["default"].div.withConfig({
  displayName: "Modalstyle__Backdrop",
  componentId: "sc-16nvlid-0"
})(function (_ref) {
  var _ref$theme = _ref.theme,
    color = _ref$theme.color,
    spacing = _ref$theme.spacing,
    show = _ref.show;
  return {
    display: show ? 'flex' : 'none',
    alignItems: 'center',
    position: 'fixed',
    overflow: 'auto',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: '100%',
    height: '100%',
    background: color.background.dark,
    boxSizing: 'border-box',
    padding: spacing.inline['3xs'],
    zIndex: 2000
  };
});
var Modal = exports.Modal = (0, _styledComponents["default"])(_.Card).withConfig({
  displayName: "Modalstyle__Modal",
  componentId: "sc-16nvlid-1"
})(function (_ref2) {
  var spacing = _ref2.theme.spacing;
  return {
    position: 'relative',
    margin: 'auto',
    width: '100%',
    maxWidth: '440px',
    padding: spacing.inline.md,
    textAlign: 'center',
    minHeight: 'auto'
  };
});
var CloseButton = exports.CloseButton = (0, _styledComponents["default"])(_.IconButton).withConfig({
  displayName: "Modalstyle__CloseButton",
  componentId: "sc-16nvlid-2"
})({
  position: 'absolute',
  top: 0,
  margin: '-15px',
  right: '0px'
});